import {BaseComponent} from '../../../shared/components/base.component';
import {Component, OnInit} from '@angular/core';
import {NotificationPerBuilding} from '../../../shared/model/notification-per-building';
import {NotificationsService} from '../../../shared/service/notifications.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BuildingsService} from '../../../shared/service/buildings.service';
import { ApplicationType, IssueNotificationStatus } from 'src/app/modules/shared/enums/enums';
import {tap} from 'rxjs/internal/operators';
import {ApplicationConfig} from '../../../../config/application.config';

@Component({
  selector: 'app-dashboard-notifications-per-building-card',
  templateUrl: './dashboard-notifications-per-building-card.component.html',
  styleUrls: ['./dashboard-notifications-per-building-card.component.scss'],
})
export class DashboardNotificationsPerBuildingCardComponent extends BaseComponent implements OnInit {

  public list: NotificationPerBuilding[];
  public isLoading: boolean;

  constructor(private notificationsService: NotificationsService, private buildingsService: BuildingsService,
              private router: Router, private route: ActivatedRoute, public applicationConfig: ApplicationConfig) {
    super();
  }

  ngOnInit() {
    this.init();
    this.getListAndBuildings();
  }

  public init() {
    this.list = [];
  }

  public goToNotificationsPage(buildingStructureId: number, application: ApplicationType) {
    this.router.navigate(['notifications'], {
        relativeTo: this.route.parent,
        queryParams: { buildingStructureId: buildingStructureId, application: application, status: IssueNotificationStatus.OPEN}
    });
  }

  public getListAndBuildings() {
    this.isLoading = true;
    this.notificationsService.getNotificationsPerBuilding()
      .pipe(
        tap(() => this.isLoading = false)
      ).subscribe(
      response => {
        this.list = response;
        this.removeBudilingsWithoutIssueNotification();
        }
    );
  }

  private removeBudilingsWithoutIssueNotification() {
    this.list = this.list.filter(v => v.numberOfOpenNotifications > 0);
  }

  public isListEmpty(): boolean {
    return !this.list.length;
  }
}
